/**
 * Free Shipping Bar — Cart Drawer JS
 * ===================================
 * ASSET: assets/free-shipping-bar-drawer.js
 *
 * Load in layout/theme.liquid just before </body>:
 * <script src="{{ 'free-shipping-bar-drawer.js' | asset_url }}" defer></script>
 */

(function () {
  var THRESHOLD = 15000; // $150.00 in cents

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  function clampLabel(el, pct) {
    var wrap = el.parentElement;
    if (!wrap) return;
    var wrapW = wrap.offsetWidth;
    if (wrapW === 0) return;
    var halfPct = (el.offsetWidth / 2 / wrapW) * 100;
    el.style.left = Math.max(halfPct, Math.min(pct, 100 - halfPct)) + '%';
  }

  function render(cartTotal) {
    var bar = document.getElementById('fs-drawer-bar');
    var fill = document.getElementById('fsd-fill');
    var msg = document.getElementById('fsd-msg');
    var current = document.getElementById('fsd-current');
    if (!bar || !fill || !msg || !current) return;

    var remaining = THRESHOLD - cartTotal;
    var pct =
      remaining <= 0 ? 100 : Math.min((cartTotal / THRESHOLD) * 100, 100);

    fill.style.width = pct + '%';

    if (remaining <= 0) {
      fill.classList.add('fsd-complete');
      msg.textContent = "You\u2019re getting free shipping! \uD83C\uDF89";
    } else {
      fill.classList.remove('fsd-complete');
      msg.textContent =
        "You\u2019re " + formatMoney(remaining) + ' away from free shipping!';
    }

    current.textContent = formatMoney(cartTotal);

    requestAnimationFrame(function () {
      clampLabel(current, pct);
    });
  }

  function fetchAndRender() {
    fetch('/cart.json')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number') {
          render(cart.total_price);
        }
      })
      .catch(function () {});
  }

  // ── Run on page load ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndRender);
  } else {
    fetchAndRender();
  }

  // ── Listen for Horizon's cart:updated event ──
  document.addEventListener('cart:updated', fetchAndRender);

  // ── Intercept fetch for AJAX cart calls ──
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return origFetch.apply(this, args).then(function (response) {
      var url =
        typeof args[0] === 'string'
          ? args[0]
          : args[0] && args[0].url
            ? args[0].url
            : '';
      if (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      ) {
        // After a cart mutation, re-fetch to get the updated total
        setTimeout(fetchAndRender, 300);
      }
      return response;
    });
  };

  // ── Intercept XMLHttpRequest ──
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._fsdUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    this.addEventListener('load', function () {
      if (
        self._fsdUrl &&
        (self._fsdUrl.indexOf('/cart/add') !== -1 ||
          self._fsdUrl.indexOf('/cart/change') !== -1 ||
          self._fsdUrl.indexOf('/cart/update') !== -1 ||
          self._fsdUrl.indexOf('/cart/clear') !== -1)
      ) {
        setTimeout(fetchAndRender, 300);
      }
    });
    return origSend.apply(this, arguments);
  };

setInterval(fetchAndRender, 30000); // 30s safety re-render
})();